export default __webpack_public_path__ + "static/media/center3.773fcd03.jpg";